import { useTranslation } from 'react-i18next';

import { useBuyPaidLineMutation } from '@/api/queries/rewards';

import { ToastNotification } from '../components/ToastNotification/ToastNotification';
import { type ActivateVipStatusResponseType } from '../types/query/user';

import { useTonAutoConnect } from './ton-auto-connect';

import coinPng from '/img/tgem.png';
import coinWebp from '/img/tgem.webp';

type PropReturn = (currency: 'XTR' | 'TON') => Promise<void>;

const useBuyPaidPlanRequest = (): PropReturn => {
  const { t } = useTranslation();
  const [buyPaidPlan] = useBuyPaidLineMutation();
  const connectWalletAndDoTransaction = useTonAutoConnect();

  const onBuyPaidPlan = async (currency: 'XTR' | 'TON'): Promise<void> => {
    if (currency === 'TON') {
      await new Promise<void>((resolve, reject) => {
        connectWalletAndDoTransaction(
          async () =>
            (await buyPaidPlan({
              currency: 'ton',
            }).unwrap()) as ActivateVipStatusResponseType,
          {
            onSuccess: () => {
              ToastNotification(t('Pending Transaction'), {
                img: coinPng,
                webp: coinWebp,
              });
              resolve();
            },
            onError: () => {
              ToastNotification(t('Something went wrong, please try again'), {
                img: coinPng,
                webp: coinWebp,
              });
              reject(new Error('Transaction failed'));
            },
          },
        );
      });
    } else {
      const response = await buyPaidPlan({
        currency: 'xtr',
      }).unwrap();

      // for ActivateVipStatusBuyLinkResponseType response type
      if ('link' in response) {
        await new Promise<void>((resolve, reject) => {
          Telegram.WebApp.openInvoice(response.link, (status) => {
            if (status === 'cancelled' || status === 'failed') {
              ToastNotification(t('Something went wrong, please try again'), {
                img: coinPng,
                webp: coinWebp,
              });
              reject(new Error(`Payment ${status}`));
            } else {
              resolve();
            }
            console.log(`payment status ${status}`);
          });
        });
      }
    }
  };

  return onBuyPaidPlan;
};

export { useBuyPaidPlanRequest };
